function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.032,0,0,0.032,0,0)",
    stroke: "none",
    style: {
      fill: "#95a5a6"
    },
    d: "M 500 135 C 700 135 864 299 864 499 C 864 700 700 864 500 864 C 299 864 135 700 135 499 C 135 299 299 135 500 135 M 500 0 C 223 0 0 223 0 499 C 0 776 223 1000 500 1000 C 776 1000 1000 776 1000 499 C 1000 223 776 0 500 0 L 500 0 z M 644 650 C 658 636 658 613 643 599 L 530 488 L 530 247 C 530 227 514 211 494 211 C 474 211 458 227 458 247 L 458 503 C 458 513 462 522 469 529 L 593 651 C 600 658 609 661 618 661 C 627 661 637 658 644 650 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.75e247ff60e6657a11c2f843b2881f8c.svg";
export { ForwardRef as ReactComponent };